import { render } from "./About.vue?vue&type=template&id=1ea7d046"
const script = {}
script.render = render

export default script